<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_government_select')
}

const isOnGovernmentSection = computed(() => {
  return route.path.startsWith('/government')
})

const goToGovernment = () => {
  router.push('/government/cabinet')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/government.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.government.select.selectFirst') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.government.select.reviewEach') }}
      </p>
      <p class="pb-2">
        <i18n-t keypath="tutorial.government.select.requireVip" tag="span">
          <template #icon><GenericIcon type="vip" /></template>
        </i18n-t>
      </p>
      <p class="pb-2">
        {{ t('tutorial.government.select.keepInMind') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.government.select.goAhead') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info">
        {{ t('tutorial.government.select.chooseMinistry') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnGovernmentSection" @click="goToGovernment" class="mr-2">
        {{ t('tutorial.government.intro.goToGovernment') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('common.actions.continue') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>